export * from "./butcher.component";
